import { MovieSiteBackgroundTexture } from '@usheru-hff/shared/domain';

export interface BackgroundTextureStyle {
  opacity: number;
  mixBlendMode: string;
}

export const textureConfig: Record<MovieSiteBackgroundTexture, BackgroundTextureStyle> = {
  checkerboard: {
    opacity: 0.40,
    mixBlendMode: 'overlay'
  }
};
